import React from 'react';
import FormSelect from 'components/forms/bases/FormSelect';

const FormTarget = ({ value, onChange, ...props }) => {
  const array = [
    { label: 'new tab', value: '_blank' },
    { label: 'exiting tab', value: '_self' },
  ];

  return (
    <FormSelect
      label="Open in"
      value={value || '_self'}
      options={array}
      onChange={(val) => onChange(val)}
      {...props}
    />
  );
};

FormTarget.propTypes = {};
FormTarget.defaultProps = {};

export default FormTarget;



// WEBPACK FOOTER //
// ./src/components/forms/FormTarget.js